import { render, staticRenderFns } from "./PaymentTermCompanies.vue?vue&type=template&id=a9849f04&scoped=true&"
import script from "./PaymentTermCompanies.vue?vue&type=script&lang=js&"
export * from "./PaymentTermCompanies.vue?vue&type=script&lang=js&"
import style0 from "./PaymentTermCompanies.vue?vue&type=style&index=0&id=a9849f04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9849f04",
  null
  
)

component.options.__file = "PaymentTermCompanies.vue"
export default component.exports